import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, Eye } from "lucide-react";
import { FormStep } from "@/components/listings/filters/FilterSchema";
import { useListingWizardContext } from "@/context/ListingWizardContext";
import { useFormNavigation } from "./hooks/useFormNavigation";
import { useFormSubmit } from "./hooks/useFormSubmit";

const FormNavigation = () => {
  const { form, currentStep, isSubmitting } = useListingWizardContext(); // Destructure 'form'

  const {
    handleNextStep,
    handlePrevStep,
    handlePreview,
    canProceedToNextStep,
  } = useFormNavigation();

  const { handleSubmit } = useFormSubmit();

  const isFirstStep = currentStep === FormStep.PropertyInformation;
  const isLastStep = currentStep === FormStep.Review;

  return (
    <div className="flex justify-between pt-6 border-t">
      <div>
        {!isFirstStep && (
          <Button
            type="button"
            variant="outline"
            onClick={handlePrevStep}
            className="flex items-center gap-1"
          >
            <ChevronLeft className="h-4 w-4" />
            Back
          </Button>
        )}
      </div>

      <div className="flex gap-3">
        {currentStep > 1 && !isLastStep && (
          <Button
            type="button"
            variant="outline"
            onClick={handlePreview}
            className="flex items-center gap-1"
            disabled={isSubmitting}
          >
            <Eye className="h-4 w-4" />
            Preview
          </Button>
        )}

        {!isLastStep ? (
          <Button
            type="button"
            onClick={handleNextStep}
            className="flex items-center gap-1"
            disabled={isSubmitting || !canProceedToNextStep}
          >
            Next
            <ChevronRight className="h-4 w-4" />
          </Button>
        ) : (
          <Button
            type="button"
            onClick={() => handleSubmit(form.getValues())} // Pass form data
            disabled={isSubmitting || !canProceedToNextStep}
          >
            Submit Listing
          </Button>
        )}
      </div>
    </div>
  );
};

export default FormNavigation;
